import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsAddIndividualResolverErrorStatesEnum {
    GetCountriesFailed = ErrorStateScheduleEnum.PanelClientsAddIndividualResolverStatesStartIndex,
    GetCountriesInvalidData,
    GetIndividualFailed,
    GetAssignedPortalsFailed,
    GetAssignedPortalsInvalidData
}
